module.exports = __webpack_public_path__ + "img/banner_tr.de2dffe6.jpg";